var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-cascader",
    _vm._b(
      {
        ref: "region",
        class: { isView: _vm.mode !== "edit" },
        staticStyle: { width: "100%" },
        attrs: {
          placeholder: _vm.placeholderTxt,
          options: _vm.regionOptions,
          filterable: "",
          clearable: "",
          props: _vm.regionProps,
          disabled: _vm.isDisabled,
        },
        on: { blur: _vm.onRegionChange, change: _vm.onRegionChange },
        model: {
          value: _vm.targetForm.PCD,
          callback: function ($$v) {
            _vm.$set(_vm.targetForm, "PCD", $$v)
          },
          expression: "targetForm.PCD",
        },
      },
      "el-cascader",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }